import { Injectable, inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';

/**
 * Reads the permission map that the backend computes at login / on /auth/me.
 * Keys are `${project}:${module}` — for this project the project is 'finances'.
 */
@Injectable({ providedIn: 'root' })
export class PermissionService {
    private authService = inject(AuthService);

    can(project: string, module: string, action: string): boolean {
        const perms = this.authService.getUser()?.permissions;
        if (!perms) return false;
        return perms[`${project}:${module}`]?.includes(action) ?? false;
    }
}
